import { topicZones } from '@/mocks/home';

export default function CategoryZones() {
  return (
    <section id="zones" className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-10 md:px-6 md:py-14">
        <div className="mb-8 text-center">
          <div className="mb-2 inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
            <i className="ri-layout-grid-line" />
            内容分区
          </div>
          <h3 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">按题材找你想看的瓜</h3>
          <p className="mx-auto mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
            八个常设分区，覆盖圈内动态到幕后揭秘，每个分区都在持续更新最新爆料与实锤进展。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {topicZones.map((zone, i) => (
            <a
              key={zone.id}
              href="#today"
              className={`group cursor-pointer rounded-lg border p-5 transition-colors ${
                i % 3 === 1
                  ? 'border-accent-200 bg-accent-50 hover:border-accent-400'
                  : 'border-background-200 bg-background-100 hover:border-primary-300'
              }`}
            >
              <div className="mb-4 flex items-start justify-between">
                <span
                  className={`flex h-11 w-11 items-center justify-center rounded-lg ${
                    i % 3 === 1 ? 'bg-accent-500 text-foreground-950' : 'bg-primary-500 text-background-50'
                  }`}
                >
                  <i className={`${zone.icon} text-xl`} />
                </span>
                <span className="rounded-md bg-background-50 px-2 py-1 text-xs text-foreground-500">{zone.count}</span>
              </div>
              <h4 className="text-base font-bold text-foreground-900 transition-colors group-hover:text-primary-600">{zone.name}</h4>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{zone.desc}</p>
              <div className="mt-4 flex items-center gap-1 text-sm text-primary-600">
                进入分区
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}